export function getWidth(): number {
  return window.innerWidth;
}
